import { Button, Typography } from '@mui/material'
import React from 'react'
import { ButtonGroupButtonProps } from './_props'
import sxs from './_sxs'
import { defaultPalette } from '../../../../theme/idsTheme'
import { hexToRgba } from '../../../../utils/commonUtils'

const ButtonGroupButton: React.FC<ButtonGroupButtonProps> = ({ active, onClick, startIcon, name, label }) => (
    <Button
        variant={active ? 'contained' : 'outlined'}
        color="primary"
        onClick={!active ? onClick : undefined}
        disableRipple={active}
        sx={[
            sxs.button,
            {
                '&:hover': {
                    background: active ? defaultPalette.primary.main : hexToRgba(defaultPalette.primary.main, 0.12),
                },
            },
        ]}
        startIcon={startIcon}
        name={name}
        disableElevation
    >
        <Typography sx={[sxs.buttonLabel]}>{label}</Typography>
    </Button>
)

export default ButtonGroupButton
